<template>
  <div class="key">
    <div v-for="(item, index) in key" :key="index">
      <Seat v-bind="item" style="width: 30px; display: inline-block" class="mb-1" />
      <div style="display: inline-block" class="ml-1">{{ item.desc }}</div>
    </div>
  </div>
</template>

<script>
import Seat from '@components/seat.vue'
export default {
  name: 'SeatMapKey',
  components: {
    Seat,
  },
  data() {
    return {
      key: [
        {
          desc: 'Available Seat',
          hasPax: false,
          seatBlock: false,
          showAttributes: false,
          seatRow: 0,
          seatColumn: 'A',
        },
        {
          desc: 'Pre-assigned',
          hasPax: false,

          seatBlock: true,
          seatBlockType: 'P',
          showAttributes: false,
          seatRow: 0,
          seatColumn: 'A',
        },
        {
          desc: 'Checked In',
          hasPax: true,
          paxType: 'CKD',
          seatBlock: false,
          showAttributes: false,
          seatRow: 0,
          seatColumn: 'A',
        },
        {
          desc: 'Boarded',
          hasPax: true,
          paxType: 'BRD',
          seatBlock: false,
          showAttributes: false,
          seatRow: 0,
          seatColumn: 'A',
        },
        {
          desc: 'Soft Blocked',
          hasPax: false,
          seatBlockType: 'SB',
          seatBlock: true,
          showAttributes: false,
          seatRow: 0,
          seatColumn: 'A',
        },
        {
          desc: 'Hard Blocked',
          hasPax: false,
          seatBlockType: 'HB',
          seatBlock: true,
          showAttributes: false,
          seatRow: 0,
          seatColumn: 'A',
        },
      ],
    }
  },
}
</script>
